import { render, staticRenderFns } from "./AppointmentBranchAdd.vue?vue&type=template&id=643d4b74"
import script from "./AppointmentBranchAdd.vue?vue&type=script&lang=ts"
export * from "./AppointmentBranchAdd.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentBranchAdd.vue?vue&type=style&index=0&id=643d4b74&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports